<template>
  <div class="dialog-wrapper">
    <div class="dialog-wrapper__popup">
      <h3>비상금 신청 상점</h3>
      <p>{{ merchant.merGrpNm }}<br>{{ merchant.regBuzNo | formatRegBuzNo }}</p>
      <button v-ripple @click="$emit('close')" class="cancel-btn" type="button">취소</button>
      <button v-ripple @click="$emit('success')" class="confirm-btn" type="submit">확인</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['merchant'],
  created() {
    this.$store.commit('ui/modalVisible', true)
  },
  destroyed() {
    this.$store.commit('ui/modalVisible', false)
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 42.5rem;
  height: 100%;
  margin: 0;
  z-index: 999;

  &__popup {
    text-align: center;
    width: calc(100% - 50px);
    max-width: 350px;
    margin: 0 auto;
    position: relative;
    background-color: #ffffff;
    margin-top: 9rem;
    padding: 30px 25px;
    height: 12.5rem;
    border-radius: 10.7px;
    animation: modal-popup-show 0.3s;
    h3 {
      font-size: 18px;
      font-weight: 800;
      margin-bottom: 16px;
    }
    p {
      font-size: 18px;
      line-height: 1.44;
      font-weight: 800;
    }
    button {
      outline: none;
      font-size: 20px;
      font-weight: 800;
      margin: 0;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      padding-top: 1rem;
      padding-bottom: 1rem;
      position: absolute;
      bottom: 0;
      z-index: 3;
    }
    .cancel-btn {
      color: rgb(114, 125, 140);
      background-color: rgb(215, 225, 234);
      left: 0;
      width: 50%;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 10.7px;
    }
    .confirm-btn {
      color: #ffffff;
      background-color: rgb(51, 51, 51);
      right: 0;
      width: 50%;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 10.7px;
    }
  }
}
@keyframes modal-popup-show {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>
